// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-c544fc0e] .el-card__header {\n  padding: 0px 0px;\n  height: 48px;\n  line-height: 48px;\n  background: #f5f6fa;\n  opacity: 1;\n  border-radius: 0px;\n  padding-left: 18px;\n  padding-right: 18px;\n}\n.title[data-v-c544fc0e] {\n  font-size: 16px;\n  font-family: Microsoft YaHei;\n  font-weight: bold;\n  color: #303033;\n  opacity: 1;\n}\n", ""]);
// Exports
module.exports = exports;
